















































import { Component, Mixins } from "vue-property-decorator";
import { SelectionModeKinds } from "../../../../domain/document";
import { DomainRegistry } from "../../../../domain";
import { CacheManager } from "../../../../utilities";
import { DialogMixin } from "../../../system/mixins";
import { UserDefinitionSelectResult } from "./UserDefinitionSelectResult";
import { UserDefinitionSelectItem } from "./UserDefinitionSelectItem";
import { UserDefinitionTextFilterKinds } from "./UserDefinitionTextFilterKinds";
import { UserDefinitionFilterPatternKinds } from "./UserDefinitionFilterPatternKinds";
import { LightTable } from "../../../../domain/system/table";
import { IConfiguration } from "../../../../domain/configuration";
import LightScrollableTable from "./LightScrollableTable.vue";
import { KeyValuePair } from "../../../../domain/system";
import FixedLoading from "../../../system/FixedLoading.vue";

@Component({
  components: {
    LightScrollableTable,
    FixedLoading,
  },
})
export default class LightUserDefinitionDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      userDefinition: null as LightTable,
      selectionMode: null,
      selctResult: null,
      textFilter: UserDefinitionTextFilterKinds.Contains,
      textFilterStartsWith: UserDefinitionTextFilterKinds.StartsWith,
      textFilterContains: UserDefinitionTextFilterKinds.Contains,
      filterPattern: UserDefinitionFilterPatternKinds.And,
      filterPatternAnd: UserDefinitionFilterPatternKinds.And,
      filterPatternOr: UserDefinitionFilterPatternKinds.Or,
      enableHalfDistinction: this.shouldDistinguishCharacterWidth(),
    };
  }
  userDefinition: LightTable;
  selectionMode: SelectionModeKinds;
  selctResult: UserDefinitionSelectResult;
  textFilter: UserDefinitionTextFilterKinds;
  filterPattern: UserDefinitionFilterPatternKinds;
  enableHalfDistinction: boolean;

  private _cache: CacheManager<string, LightTable>;

  private static async read(key: string): Promise<LightTable> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getUserDefinitionAsLightTable(key);
  }

  async show(key: string, selectionMode: SelectionModeKinds, initialFilterParameters: KeyValuePair<string, string>[] = []): Promise<UserDefinitionSelectResult> {
    return this.showModal(async () => {
      this.collectGarbage();
      this.userDefinition = null;
      this.selectionMode = selectionMode;
      this.selctResult = null;
      
      if (!this._cache) {
        // TODO: フィールド変数でnewしてるとインスタンス入っていない？（初回のshowのタイミングではまだmountされていない？）
        this._cache = new CacheManager(1, LightUserDefinitionDialog.read);
      }
      this._cache.get(key)
      .then(table => {
        if (!table || !table.rows || table.rows.length === 0) {
          this.setBlankAndClose();
          return;
        }
        // 複数の箇所で使用するときはcloneが必要になる見込みなので注意すること！
        table.clearSelection();
        table.clearFilter();
        table.setFilter(initialFilterParameters);
        this.userDefinition = table;
      })
      .catch(e => {
        this.$warn("ユーザ定義取得失敗", "ユーザ定義の取得に失敗しました。", e);
        this.setBlankAndClose();
      });
      await this.waitHidden();
      // IEでのメモリリーク対策
      this.userDefinition = null;
      this.collectGarbage();
      return this.selctResult;
    });
  }

  collectGarbage(): void {
    // IEでのメモリリーク対策
    const castedWindow = window as any;
    if (castedWindow.CollectGarbage) {
      castedWindow.CollectGarbage();
    }
  }

  setResultAndClose(): void {
    this.selctResult = this.createResult(false);
    this.isVisible = false;
  }

  clearAndClose(): void {
    this.selctResult = this.createResult(true);
    this.isVisible = false;
  }

  setBlankAndClose(): void {
    const result = new UserDefinitionSelectResult();
    result.items = [];
    result.isBlank = true;
    this.selctResult = result;
    this.isVisible = false;
  }

  createResult(isClear: boolean): UserDefinitionSelectResult {
    const items: UserDefinitionSelectItem[] = [];
    for (const header of this.userDefinition.headers) {
      const index = this.userDefinition.headers.indexOf(header);
      const values = this.getSelectedValuesByCellIndex(index);
      const item = new UserDefinitionSelectItem();
      item.name = header.value;
      item.values = isClear ? [] : values;
      items.push(item);
    }
    const result = new UserDefinitionSelectResult();
    result.items = items;
    return result;
  }

  getSelectedValuesByCellIndex(index: number): string[] {
    const values = this.userDefinition.getSelectedValuesByCellIndex(index);
    if (!values) { return []; }

    const results: string[] = [];
    for (const value of values) {
      if (!value || value === "") { continue; }
      results.push(value);
    }
    return results;
  }

  shouldDistinguishCharacterWidth(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.userDefinition.filter.default.shouldDistinguishCharacterWidth;
  }

  get rowCountPerPage(): number {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.document.editor.userDefinition.displayCountPerPage;
  }

  get hasSelected(): boolean {
    return !!this.userDefinition
      && (this.userDefinition.isSelected || this.userDefinition.areCellsSelected);
  }
}
